import * as aiAction from './ai-action'
import * as aiActionInvocation from './ai-action-invocation'
import * as agent from './agent'
import * as agentRun from './agent-run'
import * as apiKey from './api-key'
import * as appAction from './app-action'
import * as appActionCall from './app-action-call'
import * as appBundle from './app-bundle'
import * as appDefinition from './app-definition'
import * as appDetails from './app-details'
import * as appInstallation from './app-installation'
import * as appSignedRequest from './app-signed-request'
import * as appSigningSecret from './app-signing-secret'
import * as appEventSubscription from './app-event-subscription'
import * as appKey from './app-key'
import * as appAccessToken from './app-access-token'
import * as appUpload from './app-upload'
import * as asset from './asset'
import * as assetKey from './asset-key'
import * as bulkAction from './bulk-action'
import * as comment from './comment'
import * as contentType from './content-type'
import * as editorInterface from './editor-interface'
import * as entry from './entry'
import * as environment from './environment'
import * as environmentAlias from './environment-alias'
import * as environmentTemplate from './environment-template'
import * as environmentTemplateInstallation from './environment-template-installation'
import * as extension from './extension'
import * as func from './function'
import * as functionLog from './function-log'
import * as locale from './locale'
import * as oauthApplication from './oauth-application'
import * as organization from './organization'
import * as organizationInvitation from './organization-invitation'
import * as organizationMembership from './organization-membership'
import * as personalAccessToken from './personal-access-token'
import * as accessToken from './access-token'
import * as previewApiKey from './preview-api-key'
import * as release from './release'
import * as releaseAction from './release-action'
import * as role from './role'
import * as scheduledAction from './scheduled-action'
import * as semanticDuplicates from './semantic-duplicates'
import * as semanticRecommendations from './semantic-recommendations'
import * as semanticReferenceSuggestions from './semantic-reference-suggestions'
import * as semanticSearch from './semantic-search'
import * as snapshot from './snapshot'
import * as space from './space'
import * as spaceMember from './space-member'
import * as spaceMembership from './space-membership'
import * as tag from './tag'
import * as task from './task'
import * as team from './team'
import * as teamMembership from './team-membership'
import * as teamSpaceMembership from './team-space-membership'
import * as uiConfig from './ui-config'
import * as upload from './upload'
import * as usage from './usage'
import * as user from './user'
import * as userUIConfig from './user-ui-config'
import * as vectorizationStatus from './vectorization-status'
import * as webhook from './webhook'
import * as workflowDefinition from './workflow-definition'
import * as concept from './concept'
import * as conceptScheme from './concept-scheme'
import * as resourceProvider from './resource-provider'
import * as resourceType from './resource-type'
import * as resource from './resource'

export default {
  aiAction,
  aiActionInvocation,
  agent,
  agentRun,
  accessToken,
  appAction,
  appActionCall,
  appBundle,
  apiKey,
  appDefinition,
  appInstallation,
  appUpload,
  appDetails,
  appSignedRequest,
  appSigningSecret,
  appEventSubscription,
  appKey,
  appAccessToken,
  asset,
  assetKey,
  bulkAction,
  comment,
  concept,
  conceptScheme,
  contentType,
  editorInterface,
  entry,
  environment,
  environmentAlias,
  environmentTemplate,
  environmentTemplateInstallation,
  extension,
  func,
  functionLog,
  locale,
  oauthApplication,
  organization,
  organizationInvitation,
  organizationMembership,
  personalAccessToken,
  previewApiKey,
  release,
  releaseAction,
  resourceProvider,
  resourceType,
  resource,
  role,
  scheduledAction,
  semanticDuplicates,
  semanticRecommendations,
  semanticReferenceSuggestions,
  semanticSearch,
  snapshot,
  space,
  spaceMember,
  spaceMembership,
  tag,
  task,
  team,
  teamMembership,
  teamSpaceMembership,
  uiConfig,
  upload,
  usage,
  user,
  userUIConfig,
  vectorizationStatus,
  webhook,
  workflowDefinition,
}
